import { createUseStyles } from 'react-jss';
import { grayPalette } from '@tcl-argon-colors/colors';

export const useSingleDatePickerStyles = createUseStyles({
  root: { position: 'relative' },
  calendarToggle: {
    borderRadius: '0px 3px 3px 0',
    boxShadow: 'none',
    // TODO find a better alternative to these magic numbers
    // This will break when someone uses a multi-line label
    position: 'absolute',
    right: '-2px',
    top: '27px',
  },
  calendarContainer: {
    backgroundColor: 'white',
    border: `1px solid ${grayPalette.gray30}`,
    display: 'none',
    left: 0,
    position: 'absolute',
    top: 'calc(100% + 10px)',
    width: '275px',
  },
  open: {
    display: 'flex',
    flexDirection: 'column',
    zIndex: 1,
  },
  calendarInput: { margin: '0 auto' },
  calendarButtonContainer: {
    display: 'flex',
    padding: '10px 40px',
    justifyContent: 'center',
  },
  clearButton: {
    flex: '0 0 50%',
  },
});
